import { useTranslations } from 'next-intl';

import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import type { ShipmentStatus } from '../types';

const statusStyles: Record<ShipmentStatus, string> = {
  draft:
    'bg-orange-100 text-orange-800 hover:bg-orange-100 dark:bg-orange-900 dark:text-orange-200',
  ready_for_shipping:
    'bg-green-100 text-green-800 hover:bg-green-100 dark:bg-green-900 dark:text-green-200',
  in_transit:
    'bg-blue-100 text-blue-800 hover:bg-blue-100 dark:bg-blue-900 dark:text-blue-200',
  received:
    'bg-teal-100 text-teal-800 hover:bg-teal-100 dark:bg-teal-900 dark:text-teal-200'
};

const statusTranslationKeys: Record<ShipmentStatus, string> = {
  draft: 'statusDraft',
  ready_for_shipping: 'statusReadyForShipping',
  in_transit: 'statusInTransit',
  received: 'statusReceived'
};

interface ShippingStatusBadgeProps {
  status: ShipmentStatus;
}

export function ShippingStatusBadge({ status }: ShippingStatusBadgeProps) {
  const t = useTranslations('shipping');

  return (
    <Badge variant='secondary' className={cn(statusStyles[status])}>
      {t(statusTranslationKeys[status])}
    </Badge>
  );
}
